/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "moving-box-bf2bb53c--sprite",
  "use": "moving-box-bf2bb53c--sprite-usage",
  "viewBox": "0 0 35.999 35.998",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 35.999 35.998\" id=\"moving-box-bf2bb53c--sprite\"><g opacity=\"0\"><path d=\"M-87.779-105.444a18,18,0,0,1,18,18,18,18,0,0,1-18,18,18,18,0,0,1-18-18h0A18,18,0,0,1-87.779-105.444Z\" transform=\"translate(105.778 105.444)\" fill=\"#fcf8d0\" /></g><g transform=\"translate(8.682 8.17)\"><path d=\"M-77.191-87.333l2.865,1.448-8.4,4.6-3.156-1.65Zm-.531,20.292-8.813-4.614V-82.029l3.167,1.657v1.51l.42.051.715.781.752.151.593.56v-1.762l3.167,1.657Zm-2.565-12.967,8.575-4.559,3.267,1.65-8.726,4.537Zm12.479,8.349-8.809,4.6V-77.422L-67.807-82Z\" transform=\"translate(86.534 87.333)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
